import React from "react";
import { Link, NavLink } from "react-router-dom";
import { AdminEmptyState, adminHeroActionClassName } from "../ui";

export function SubscriptionEmptyState(): React.JSX.Element {
  return (
    <AdminEmptyState
      title="Aucun abonnement enregistré"
      description="Créez un abonnement à partir d’un client pour activer la planification, les dotations et la facturation."
      action={
        <div className="flex flex-col items-center gap-3 sm:flex-row">
          <Link
            to="/admin/clients"
            className="inline-flex items-center justify-center rounded-xl border border-slate-600 bg-slate-800/80 px-4 py-2.5 text-sm font-medium text-white hover:bg-slate-800"
          >
            Voir clients
          </Link>
          <NavLink
            to="/admin/clients/nouveau"
            className={({ isActive }) => adminHeroActionClassName(isActive)}
          >
            Créer nouveau client
          </NavLink>
          <Link
            to="/admin/categories-tarifs"
            className="inline-flex items-center justify-center rounded-xl border border-emerald-500/30 bg-emerald-500/10 px-4 py-2.5 text-sm font-semibold text-emerald-200 hover:bg-emerald-500/15"
          >
            Préparer plans d’abonnement
          </Link>
        </div>
      }
    />
  );
}
